import { Phone, MessageCircle, MapPin } from "lucide-react";
import { INFO, waLink } from "@/lib/data";
import { scrollToId } from "./SmoothScroll";

export default function StickyBar() {
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-bone/90 backdrop-blur-xl border-t border-charcoal/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3">
        <a href={`tel:${INFO.phoneTel}`} data-testid="sticky-call" className="flex flex-col items-center gap-1 py-3 text-charcoal active:bg-sand transition-colors">
          <Phone size={19} className="text-terracotta" />
          <span className="text-[11px] font-sans font-medium">Chiama</span>
        </a>
        <button onClick={() => scrollToId("prenota")} data-testid="sticky-prenota" className="flex flex-col items-center gap-1 py-3 bg-terracotta text-bone active:bg-terracotta-dark transition-colors">
          <MessageCircle size={19} />
          <span className="text-[11px] font-sans font-semibold">Prenota</span>
        </button>
        <a href={INFO.mapLink} target="_blank" rel="noopener noreferrer" data-testid="sticky-map" className="flex flex-col items-center gap-1 py-3 text-charcoal active:bg-sand transition-colors">
          <MapPin size={19} className="text-terracotta" />
          <span className="text-[11px] font-sans font-medium">Mappa</span>
        </a>
      </div>
    </div>
  );
}
